import { useTranslation } from 'react-i18next'

export function ImprintPage() {
  const { t } = useTranslation('legal')

  return (
    <article data-testid="imprint-page">
      <h2 className="section-heading">{t('imprint.heading')}</h2>
      <p className="muted">{t('imprint.intro')}</p>

      <h3 className="section-heading" style={{ marginTop: 24 }}>
        {t('imprint.providerHeading')}
      </h3>
      <p>
        <strong>Infin8 World LLC</strong>
      </p>
      <p>
        7901 4th St N, STE 300
        <br />
        St. Petersburg, FL 33701
        <br />
        USA
      </p>

      <h3 className="section-heading" style={{ marginTop: 24 }}>
        {t('imprint.contactHeading')}
      </h3>
      <p>
        {t('imprint.emailLabel')}: heliumtrackerio@infin8.world
        <br />
        {t('imprint.webLabel')}: https://www.heliumtracker.io
        <br />
        {t('imprint.supportLabel')}: Discord (discord.gg/tqZrnjgMHz), X/Twitter @HeliumTracker
      </p>

      <p className="muted" style={{ marginTop: 24 }}>
        {t('imprint.copyright')}
      </p>
    </article>
  )
}
